import firebase from 'firebase/compat/app';
import {
    getDocs,
    query,
    collection,
    where,
    QueryConstraint,
    setDoc,
    doc,
    updateDoc
} from "firebase/firestore";
import {Staff, staffFromJson} from "../../models/staff/staff";
import {auth, firestore, functions} from "../../firebase";
import {cast} from "mobx-state-tree";
import {generate} from "generate-password"
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';

export class StaffFirestore {


    async getStaff(businessId: string) {
        try {
            const whereClauses: QueryConstraint[] = []
            whereClauses.push(where("businessId", "==", businessId), where("isDeleted", "==", false))
            const q = query(collection(firestore, "staff"), ...whereClauses);

            const querySnapshot = await getDocs(q)
            const data: Staff[] = []
            querySnapshot.docs.forEach(doc => {
                const staffItem = staffFromJson(doc.data())
                data.push({...staffItem, projectIds: cast(staffItem.projectIds) })
            })

            return {kind: "ok", data}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async addStaff(formData: {
        name: string, role: string, email: string, projectIds: string[]
    }, businessId: string) {
        try {
            const password = generate({
                length: 12,
                numbers: true,
                symbols: true,
                uppercase: true,
                lowercase: true
            });

            const credentials = await createUserWithEmailAndPassword(auth, formData.email, password);

            const staffData = {
                id: credentials.user.uid,
                businessId,
                name: formData.name,
                email: formData.email,
                projectIds: formData.projectIds,
                isDeleted: false,
                role: formData.role,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await setDoc(doc(firestore, "staff", credentials.user.uid), staffData)

            const sendVerificationMailFunction = httpsCallable<{
                name: string,
                email: string,
                password: string,
                isStaff: boolean
            }, any>(functions,"sendVerificationMail");

            console.log("sendVerificationMailFunction", {
                name: formData.name,
                email: formData.email,
                password: password,
                isStaff: true
            })

            await sendVerificationMailFunction({
                name: formData.name,
                email: formData.email,
                password: password,
                isStaff: true
            });

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async updateStaff(id: string, formData: {
        name: string, role: string, projectIds: string[]
    }) {
        try {

            const staffData = {
                ...formData,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "staff", id), staffData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async deleteStaff(id: string) {
        try {
            const staffData = {
                isDeleted: true,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "staff", id), staffData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }
}
